import React, {
  createContext,
  useContext,
  useReducer,
  useState,
  Dispatch,
  useEffect
} from "react";
import CartReducer from "./CartReducer";
import { Product } from "data/data"; // Ensure this path is correct
import Cookies from "js-cookie";

type ReducerAction = {
  type: string;
  payload: any;
};

interface InitialState {
  Products: [];
  state: Product[];
  dispatch: Dispatch<ReducerAction>;
  total_price: any;
}

const Cartcontext = createContext<InitialState>({
  Products: [],
  dispatch: () => undefined,
  state: [],
  total_price: "",
});

const initialValue = () => {
  try {
    const initialState = localStorage.getItem("orderCards");
    if (!initialState) {
      return {
        Products: [],
        total_price: "",
      };
    }
    return JSON.parse(initialState);
  } catch (error) {
    console.error("Error parsing initial state from cookies:", error);
    return {
      Products: [],
      total_price: "",
    };
  }
};

export const ProductCartContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [state, dispatch] = useReducer(CartReducer, initialValue());
  const [searchProduct, setSearchProduct] = useState<String>("");

  useEffect(() => {
    localStorage.setItem("orderCards", JSON.stringify(state));
  }, [state]);

  const value = {
    ...state,
    dispatch,
    searchProduct,
    setSearchProduct,
  };

  return <Cartcontext.Provider value={value}>{children}</Cartcontext.Provider>;
};

export const useCartDataProvider = () => {
 
  return useContext(Cartcontext);
};
